// Formato de fechas y números según el idioma de la web.
const LOCALES = { es: 'es-ES', en: 'en-GB', zh: 'zh-CN' };

export const localeOf = (language) => LOCALES[language] || LOCALES.es;

export default localeOf;
